const SEO = [
	{
		page: "home",
		description:
			"Swapnil Tamse is an engineering leader building AI systems in financial services, with 15+ years across full-stack development, cloud, and team leadership.",
		keywords: [
			"Swapnil Tamse",
			"AI engineering leader",
			"AI engineer",
			"engineering leadership",
			"FinServ AI",
			"React Node.js AWS",
			"NYC",
		],
	},

	{
		page: "about",
		description:
			"A hands-on AI engineering leader who still ships code. A player-coach with 15 years in financial services, building and leading teams in NYC.",
		keywords: [
			"Swapnil Tamse",
			"AI engineering leader",
			"engineering manager",
			"full stack engineer",
			"React Node.js AWS",
			"FinServ",
		],
	},

	{
		page: "articles",
		description:
			"Long-form writing on AI engineering, building software, and leading teams. Notes from Swapnil Tamse on what actually works.",
		keywords: [
			"Swapnil Tamse",
			"AI engineering",
			"software engineering writing",
			"engineering leadership",
			"technical blog",
		],
	},

	{
		page: "projects",
		description:
			"Projects by Swapnil Tamse spanning AI systems, full-stack apps, and developer tools. Many are open-source and available on GitHub.",
		keywords: [
			"Swapnil Tamse",
			"AI projects",
			"open source",
			"React Node.js AWS",
			"developer tools",
		],
	},

	{
		page: "contact",
		description:
			"Reach out to Swapnil Tamse about AI engineering, building software, or engineering leadership. Open to new ideas and collaboration.",
		keywords: [
			"Swapnil Tamse",
			"contact",
			"AI engineering leader",
			"collaboration",
			"NYC",
		],
	},
];

export default SEO;
